import { Fragment } from "react";
import { UStyles } from "@/app/utils/UStyles";
import { splitInlineCode } from "./CodeText.logic";
import styles from "./CodeText.module.css";

export enum CodeTextType {
  INLINE = "inline",
  BLOCK = "block",
}

type Props = {
  text: string;
  type?: CodeTextType;
  border?: boolean;
};

export default function CodeText(props: Props) {
  const { text, type = CodeTextType.INLINE, border = false } = props;

  if (type === CodeTextType.BLOCK) {
    return (
      <pre className={UStyles.classNames(styles.block, border ? styles.bordered : "")}>{text}</pre>
    );
  }

  const parts = splitInlineCode(text);

  return (
    <>
      {parts.map((part, index) =>
        part.code ? (
          <code
            key={`${index}-${part.text}`}
            className={UStyles.classNames(styles.inline, border ? styles.bordered : "")}
          >
            {part.text}
          </code>
        ) : (
          <Fragment key={`${index}-${part.text}`}>{part.text}</Fragment>
        ),
      )}
    </>
  );
}
